import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@uhg-abyss/web/ui/Chip';
import { event } from '@uhg-abyss/web/tools/event';
import { facetChangeEvent } from '../../../events';

export const FacetChips = ({
  controller,
  filterTitle,
  setSelectedFacets,
  selectedFacets,
}) => {
  const handleFacetToggle = (item, title) => {
    const isValueSelected = !controller?.isValueSelected(item);
    controller.toggleSelect(item);

    if (isValueSelected) {
      setSelectedFacets((prev) => {
        const updatedFacets = [
          ...prev,
          { fieldName: title, value: item.value },
        ];
        event.setData(
          facetChangeEvent({
            searchEventTrigger: 'facetSelect',
            searchFacetValues: updatedFacets,
          })
        );
        return updatedFacets;
      });
    } else {
      // remove unselected filter - if match between fieldName and value is found, return false
      const filteredFacets = (selectedFacets || []).filter(
        (facet) => !(facet.fieldName === title && facet.value === item.value)
      );
      event.setData(
        facetChangeEvent({
          searchEventTrigger: 'facetDeselect',
          searchFacetValues: filteredFacets,
        })
      );
      setSelectedFacets(filteredFacets);
    }
  };

  return (
    <React.Fragment>
      <If
        condition={
          controller?.state?.values?.length > 0 &&
          controller.state.hasActiveValues
        }
      >
        <For each="item" of={controller?.state?.values}>
          <If condition={controller.isValueSelected(item)}>
            <Chip
              onClose={() => handleFacetToggle(item, filterTitle)}
              text={item.value}
            />
          </If>
        </For>
      </If>
    </React.Fragment>
  );
};

FacetChips.propTypes = {
  filterTitle: PropTypes.string,
  controller: PropTypes.shape({
    state: PropTypes.shape({
      hasActiveValues: PropTypes.bool.isRequired,
    }),
    subscribe: PropTypes.func.isRequired,
    toggleSelect: PropTypes.func.isRequired,
    isValueSelected: PropTypes.func.isRequired,
    sortBy: PropTypes.func.isRequired,
    showMoreValues: PropTypes.func.isRequired,
  }),
  setSelectedFacets: PropTypes.func.isRequired,
  selectedFacets: PropTypes.arrayOf(PropTypes.shape({})),
};

FacetChips.defaultProps = {
  filterTitle: '',
  controller: {
    state: {},
  },
  selectedFacets: [],
};
